/**
 * Shown on mobile web only (not in PWA). Guides users to install the app.
 * Currently disabled — do not prompt users to install as PWA.
 */

import React from 'react';

export default function PWAInstallBanner() {
  return null;
}
